import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import $ from 'jquery';
import { useUser } from '../contexts/UserContext';
import { Button } from '@mui/material';
import OpcionesTicket from '../Tickets/OpcionesTickets'; // Asegúrate de tener este componente creado y el path correcto.
import OpcionesAtencionTickets from '../Tickets/OpcionesAtencionTickets'; // Asegúrate de tener este componente creado y el path correcto.
import { useSucursal } from '../contexts/SucursalContext';
import { clearToken } from '../utils/apiInterceptor';


const Header = () => {
  const rightColRef = useRef(null);
  const bodyRef = useRef(document.body);
  const sidebarMenuRef = useRef(null);
  const navMenuRef = useRef(null);
  const footerRef = useRef(null);
  const sidebarFooterRef = useRef(null);
  const menuToggleRef = useRef(null);
  const { user } = useUser();
  const navigate = useNavigate();
  const [openOpcionesTicket, setOpenOpcionesTicket] = useState(false);
  const [openOpcionesAtencionTickets, setOpenOpcionesAtencionTickets] = useState(false);
  const { cajaAbierta } = useSucursal();

  // Función para manejar el logout
// Función para manejar el Logout
const handleLogout = () => {
  // ✅ limpiar datos de sesión
  localStorage.removeItem("isAuthenticated");
  localStorage.removeItem("token");
  localStorage.removeItem("username");
  localStorage.removeItem("sucursalSeleccionada");
  localStorage.removeItem("accesos");
  localStorage.removeItem("permisos");

  // Si tienes otras llaves del sistema, agrégalas aquí también:
  // localStorage.removeItem("cubiculoTomaMuestra");

  clearToken(); // (ya hace removeItem('token'), pero no estorba)

  // ✅ Redirigir al login
  navigate("/login", { replace: true });
};
  
  useEffect(() => {
    const $RIGHT_COL = $(rightColRef.current);
    const $BODY = $(bodyRef.current);
    const $SIDEBAR_MENU = $(sidebarMenuRef.current);
    const $NAV_MENU = $(navMenuRef.current);
    const $FOOTER = $(footerRef.current);
    const $SIDEBAR_FOOTER = $(sidebarFooterRef.current);
    const $MENU_TOGGLE = $(menuToggleRef.current);

    const setContentHeight = () => {
      // reset height
      $RIGHT_COL.css('min-height', $(window).height());

      const bodyHeight = $BODY.outerHeight();
      const footerHeight = $BODY.hasClass('footer_fixed') ? -10 : $FOOTER.height();
      const leftColHeight = $SIDEBAR_FOOTER.height();
      const contentHeight = bodyHeight < leftColHeight ? leftColHeight : bodyHeight;

      // normalize content
      const finalContentHeight = contentHeight - $NAV_MENU.height() - footerHeight;

      $RIGHT_COL.css('min-height', finalContentHeight);
    };

    const openUpMenu = () => {
      $SIDEBAR_MENU.find('li').removeClass('active active-sm');
      $SIDEBAR_MENU.find('li ul').slideUp();
    };

    $SIDEBAR_MENU.find('a').on('click', function (ev) {
      const $li = $(this).parent();

      if ($li.is('.active')) {
        $li.removeClass('active active-sm');
        $('ul:first', $li).slideUp(() => {
          setContentHeight();
        });
      } else {
        // prevent closing menu if we are on child menu
        if (!$li.parent().is('.child_menu')) {
          openUpMenu();
        } else {
          if ($BODY.is('nav-sm')) {
            if (!$li.parent().is('child_menu')) {
              openUpMenu();
            }
          }
        }

        $li.addClass('active');

        $('ul:first', $li).slideDown(() => {
          setContentHeight();
        });
      }
    });

    // toggle small or large menu
    $MENU_TOGGLE.on('click', () => {
      if ($BODY.hasClass('nav-md')) {
        $SIDEBAR_MENU.find('li.active ul').hide();
        $SIDEBAR_MENU.find('li.active').addClass('active-sm').removeClass('active');
      } else {
        $SIDEBAR_MENU.find('li.active-sm ul').show();
        $SIDEBAR_MENU.find('li.active-sm').addClass('active').removeClass('active-sm');
      }

      $BODY.toggleClass('nav-md nav-sm');

      setContentHeight();

      // **ajuste margin-left de la columna derecha**
    if ($BODY.hasClass('nav-sm')) {
      $RIGHT_COL.css('margin-left', '70px');
    } else {
      $RIGHT_COL.css('margin-left', '230px');
    }

      $('.dataTable').each(function () { $(this).dataTable().fnDraw(); });
    });

    // check active menu
    $SIDEBAR_MENU.find('a[href="' + window.location.href + '"]').parent('li').addClass('current-page');

    $SIDEBAR_MENU.find('a').filter(function () {
      return this.href === window.location.href;
    }).parent('li').addClass('current-page').parents('ul').slideDown(() => {
      setContentHeight();
    }).parent().addClass('active');
    

    // recompute content when resizing
    $(window).on('resize', () => {
      setContentHeight();
    });

    setContentHeight();

    // fixed sidebar
    if ($.fn.mCustomScrollbar) {
      $('.menu_fixed').mCustomScrollbar({
        autoHideScrollbar: true,
        theme: 'minimal',
        mouseWheel: { preventDefault: true }
      });
    }

    return () => {
      $(window).off('resize');
      $SIDEBAR_MENU.find('a').off('click');
      $MENU_TOGGLE.off('click');
    };
  }, []);

  return (
    <div className="App">
      {/* top navigation */}
      <div className="top_nav">
        <div className="nav_menu">
          <div className="nav toggle">
            <a id="menu_toggle" ref={menuToggleRef}><i className="fa fa-bars" /></a>
          </div>
          <nav className="nav navbar-nav">



            <ul className="navbar-right">
              <li className="nav-item dropdown open" style={{ paddingLeft: 15 }}>
              
              {user?.codUsuarioTickets && user.codUsuarioTickets > 0 && (
                <>
                  <span style={{ paddingRight: 15 }}>
                    <Button
                      variant="contained"
                      onClick={() => setOpenOpcionesAtencionTickets(true)}
                      style={{ backgroundColor: '#2196f3', color: '#fff' }} // Azul Material Design y texto blanco
                    >
                      Gestion Tickets
                    </Button>
                  </span>
                  <span style={{ paddingRight: 15 }}>
                    <Button
                      variant="contained"
                      onClick={() => setOpenOpcionesTicket(true)}
                      style={{ backgroundColor: '#2196f3', color: '#fff' }} // Azul Material Design y texto blanco
                    >
                      Configuracion Tickets
                    </Button>
                  </span>
                </>
              )}

                <a href="#" onClick={e => e.preventDefault()} className="user-profile dropdown-toggle" aria-haspopup="true" id="navbarDropdown" data-toggle="dropdown" aria-expanded="false">
                  <img src="./images/avatar_index.jpg" alt="Avatar" />{user?.codigoUsuario}
                </a>
                <div className="dropdown-menu dropdown-usermenu pull-right" aria-labelledby="navbarDropdown">
                  <a className="dropdown-item" href="#" onClick={e => e.preventDefault()}>
                    <span>Configuracion</span>
                  </a>
                  <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                    <i className="fa fa-sign-out pull-right" /> Salir
                  </a>
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <OpcionesTicket
        open={openOpcionesTicket}
        onClose={() => setOpenOpcionesTicket(false)}
      />
      <OpcionesAtencionTickets
        open={openOpcionesAtencionTickets}
        onClose={() => setOpenOpcionesAtencionTickets(false)}
      />
    </div>
  );
};

export default Header;
